import { Component, Prop, h, Event, EventEmitter, State, Watch } from '@stencil/core';
import { InputFomat } from '../model/input.model';

@Component({
  tag: 'form-select',
  styleUrl: 'form-select.css',
  shadow: false,
})
export class FormSelect {
  @Prop() inputValue: InputFomat;
  @Event() valueChanged: EventEmitter<{ id: string; value: any }>;
  @Prop() resetKey: number;
  @State() currentValue: any;

  componentWillLoad() {
    this.currentValue = this.inputValue.default ?? '';
  }

  @Watch('resetKey')
  onResetKeyChanged() {
    this.currentValue = this.inputValue.default ?? '';
  }

  private handleInput = (event: Event) => {
    const target = event.target as HTMLInputElement;
    const value = target.value;
    this.currentValue = value;
    this.valueChanged.emit({ id: this.inputValue.id, value });
  };


  render() {
    return (
      <div class="form-box">
        <label htmlFor={this.inputValue.id}>{this.inputValue.label || this.inputValue.id} {this.inputValue.required === true ? '*' : ''}</label>
        <ix-select
          value={this.currentValue}
          id={this.inputValue.id}
          onValueChange={(event) => this.handleInput(event)}
          helperText={this.inputValue.helperText}
        >
          {Object.entries(this.inputValue.options).map(([key, val]) =>
            <ix-select-item label={val} value={key}>{val}</ix-select-item>
          )}
        </ix-select>
        <br />
      </div>
    );
  }
}
